const { default: axios } = require("axios");
import { createApp } from 'vue';
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

window.addEventListener('load',function() {
    
    var tr;

    if(tr = document.querySelector(".trigger")) {
        tr.addEventListener("click", function (el) {
            if (tr.classList.contains("open")) {
                tr.classList.remove("open");
                document.querySelector("body").classList.remove("scroll-lock");
                document.getElementById("mobile_menu").classList.remove("open");
            } else {
                tr.classList.add("open");
                document.querySelector("body").classList.add("scroll-lock");
                document.getElementById("mobile_menu").classList.add("open");
            }
        });
}

    document.querySelectorAll('.wp-block-jj-accordion').forEach(function(el) {
        console.log(el);
        el.addEventListener('click', function() {
            console.log(el);
            var parentEl = el.parentElement;
            var dataClass = el.getAttribute('data-class');
            if(dataClass && document.querySelector('.'+dataClass)) {                
                document.querySelector('.'+dataClass).classList.add('show');
            }
            var h = el.querySelector('.inner>div').clientHeight;
            document.querySelectorAll('.wp-block-jj-accordion').forEach(function(elOther) {
                if(elOther != el) {
                    elOther.querySelector('.inner').style.height = '0px';
                    elOther.classList.remove('open');
                }
            });
            if (el.classList.contains('open')) {
                el.querySelector('.inner').style.height = '0px';
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
                window.setTimeout(
                    function() {
                        var rect = el.getBoundingClientRect();
                            if(rect.top < 144) {
                                el.scrollIntoView();
                            }
                        }, 400
                    )
                }
            });
            if(el.classList.contains('initialOpen')) {
                el.querySelector('.inner').style.height = el.querySelector('.inner>div').clientHeight + 'px';
                var dataClass = el.getAttribute('data-class');
                document.querySelector('.'+dataClass).classList.toggle('show');
            }
    });

})